import { render, staticRenderFns } from "./layout-product-viewer360.vue?vue&type=template&id=15fee082&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&xmlns%3Av-touch=http%3A%2F%2Fwww.w3.org%2F1999%2Fxhtml&"
import script from "./layout-product-viewer360.vue?vue&type=script&lang=js&"
export * from "./layout-product-viewer360.vue?vue&type=script&lang=js&"
import style0 from "./layout-product-viewer360.vue?vue&type=style&index=0&id=15fee082&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15fee082",
  null
  
)

export default component.exports